import { useRef, useState } from 'react';
export function useDialogState() {
    const [isOpen, setIsOpen] = useState(false);
    const hasEverBeenOpen = useRef(false);
    if (isOpen && !hasEverBeenOpen.current) {
        hasEverBeenOpen.current = true;
    }
    return { isOpen, setIsOpen, hasEverBeenOpen: hasEverBeenOpen.current };
}
